import { el } from './ui'

// Words written ready for an enquiry, which the owner can change before sending (Liam, 10 Oct 2026: "there was no way
// to change the message before i sent it maybe that message box should be editable?"). The first reply and the nudge on
// New jobs and on Messages are one box each, shared by both screens, kept on this phone while the app is open, and
// forgotten once the message is sent. WhatsApp, Text and Email open with exactly what the box says.
const edited = new Map<string, string>()

// One box per enquiry and message: 'first' (the first reply), 'nudge', or 'answer' (the answer to a reply that gave the
// number of windows, with the price; Messages' They replied, 16 Oct 2026), or 'final' (the last enquiry message).
export const readyKey = (leadId: number, which: 'first' | 'nudge' | 'answer' | 'final'): string => `${leadId}:${which}`
export function readyWords(key: string, standard: string): string {
  return edited.get(key) ?? standard
}
export function setReadyWords(key: string, words: string): void { edited.set(key, words) }
export function forgetReady(key: string): void {
  edited.delete(key)
}

export function readyBox(key: string, standard: string, label: string): HTMLElement {
  const box = el('div', { class: 'ready-words' })
  const words = readyWords(key, standard)
  // Tall enough for the whole message at a phone's width (about 34 letters a line), never more than 14 lines.
  const lines = words.split('\n').reduce((n, line) => n + Math.max(1, Math.ceil(line.length / 34)), 0)
  const area = el('textarea', { class: 'ready-words-input', rows: String(Math.min(14, Math.max(4, lines + 1))), 'aria-label': label }) as HTMLTextAreaElement
  area.value = words
  const reset = el('button', { type: 'button', class: 'link-button ready-words-reset' }, 'Back to the usual wording') as HTMLButtonElement
  reset.hidden = !edited.has(key)
  area.addEventListener('input', () => {
    if (area.value === standard) edited.delete(key)
    else edited.set(key, area.value)
    reset.hidden = !edited.has(key)
  })
  reset.addEventListener('click', () => { edited.delete(key); area.value = standard; reset.hidden = true })
  box.append(area, reset)
  return box
}
